import { useCallback, useMemo } from "react";
import { useModal } from ".";
import { useAtom } from "jotai";
import dialogDataAtom from "@/atom/dialogData";
import { DialogData } from "@/model";


export const GLOBAL_DIALOG_ID = "global-dialog-id";

export const useDialog = () => {
    const modal = useModal();
    const [data, setData] = useAtom(dialogDataAtom);

    const open = useCallback((params: DialogData) => {
        modal.open(GLOBAL_DIALOG_ID);
        setData(params);
    }, [modal, setData]);

    const close = useCallback(() => {
        modal.close(GLOBAL_DIALOG_ID);
    }, [modal]);

    return useMemo(() => {
        return {
            open,
            close,
            data
        };
    }, [open, close, data]);
};
